<div style="width: 370px; margin: 10px; ">
        <div>
                <img style="height: 48px;" [src]="('/assets/img/' + this.TeamIcon).replace('//', '/').toLowerCase()"  />LINEUP
        </div>
        <app-text-divider DividerText="{{'PLAYER.FORWARDS' | translate | uppercase}}"></app-text-divider>
                <table style="width: 100%; margin-left: 20px;">
                        <tr>
                                <td>LW</td>
                                <td>CE</td>
                                <td>RW</td>
                        </tr>
                        <tr>
                                <td><app-lineup-player-card [Player]="lineupMap.get('1ST_LW')"></app-lineup-player-card></td>
                                <td><app-lineup-player-card [Player]="lineupMap.get('1ST_CE')"></app-lineup-player-card></td>
                                <td><app-lineup-player-card [Player]="lineupMap.get('1ST_RW')"></app-lineup-player-card></td>
                        </tr>
                        <tr>
                                <td><app-lineup-player-card [Player]="lineupMap.get('2ND_LW')"></app-lineup-player-card></td>
                                <td><app-lineup-player-card [Player]="lineupMap.get('2ND_CE')"></app-lineup-player-card></td>
                                <td><app-lineup-player-card [Player]="lineupMap.get('2ND_RW')"></app-lineup-player-card></td>
                        </tr>
                        <tr>
                                <td><app-lineup-player-card [Player]="lineupMap.get('3RD_LW')"></app-lineup-player-card></td>
                                <td><app-lineup-player-card [Player]="lineupMap.get('3RD_CE')"></app-lineup-player-card></td>
                                <td><app-lineup-player-card [Player]="lineupMap.get('3RD_RW')"></app-lineup-player-card></td>
                        </tr>
                        <tr>
                                <td><app-lineup-player-card [Player]="lineupMap.get('4TH_LW')"></app-lineup-player-card></td>
                                <td><app-lineup-player-card [Player]="lineupMap.get('4TH_CE')"></app-lineup-player-card></td>
                                <td><app-lineup-player-card [Player]="lineupMap.get('4TH_RW')"></app-lineup-player-card></td>
                        </tr>
                </table>

                <app-text-divider DividerText="{{'PLAYER.DEFENDERS' | translate | uppercase}}"></app-text-divider>
                <table style="width: 100%; margin-left: 20px;">
                        <tr>
                                <td><app-lineup-player-card [Player]="lineupMap.get('1ST_LD')"></app-lineup-player-card></td>

                                <td><app-lineup-player-card [Player]="lineupMap.get('1ST_RD')"></app-lineup-player-card></td>
                        </tr>
                        <tr>
                                <td><app-lineup-player-card [Player]="lineupMap.get('2ND_LD')"></app-lineup-player-card></td>

                                <td><app-lineup-player-card [Player]="lineupMap.get('2ND_RD')"></app-lineup-player-card></td>
                        </tr>
                        <tr>
                                <td><app-lineup-player-card [Player]="lineupMap.get('3RD_LD')"></app-lineup-player-card></td>

                                <td><app-lineup-player-card [Player]="lineupMap.get('3RD_RD')"></app-lineup-player-card></td>
                        </tr>
                        <tr>
                                <td><app-lineup-player-card [Player]="lineupMap.get('4TH_LD')"></app-lineup-player-card></td>

                                <td><app-lineup-player-card [Player]="lineupMap.get('4TH_RD')"></app-lineup-player-card></td>
                        </tr>
                </table>



        <app-text-divider DividerText="{{'PLAYER.GOALTENDERS' | translate | uppercase}}"></app-text-divider>
        <table style="width: 100%; margin-left: 20px;">
                <tr>
                        <td><app-lineup-player-card [Player]="lineupMap.get('1ST_GT')"></app-lineup-player-card></td>

                        <td><app-lineup-player-card [Player]="lineupMap.get('2ND_GT')"></app-lineup-player-card></td>
                </tr>
        </table>


</div>
